"use client";

import { IntlErrorCode, NextIntlClientProvider, useLocale } from "next-intl";

export default function IntlErrorHandlingProvider({ children }) {
  const locale = useLocale();
  function onError(error) {
    // Missing message hatalarını console'da gösterme
    if (error.code === IntlErrorCode.MISSING_MESSAGE) {
      // Sessizce geç, console'a yazdırma
      return;
    } else {
      // Diğer hatalar için console'a yazdır (format hataları vs.)
      console.error("next-intl client error:", error);
    }
  }

  function getMessageFallback({ namespace, key, error }) {
    const path = [namespace, key].filter((part) => part != null).join(".");

    if (error.code === IntlErrorCode.MISSING_MESSAGE) {
      // Sadece key'i döndür, ek açıklama ekleme
      return path;
    } else {
      // Format hataları için daha açıklayıcı mesaj
      return `[Format Error: ${path}]`;
    }
  }

  return (
    <NextIntlClientProvider
      locale={locale}
      onError={onError}
      getMessageFallback={getMessageFallback}
    >
      {children}
    </NextIntlClientProvider>
  );
}
